import React from 'react';
const movingCar = require('../../../assets/images/moving-car_02.png');
const background = require('../../../assets/images/dealership-background-image.png');
const pineappleLogo = require('../../../assets/images/pineapple-logo.png');
const support = require('../../../assets/images/icons/support.png');

export const DealershipBackground = (props) => {
  const { children } = props

  return (
    <div
      className='auth-container'
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        backgroundPosition: 'center center',
        margin: '0 auto',
        backgroundColor: '#FFF'
      }}
    >
      <img src={pineappleLogo} alt='logo' className='pineapple-logo' />
      <img src={movingCar} alt='car' className='background-car' />

      <div className='auth-wrapper'>
        {children}
      </div>

      {/* Support */}
      <button className='support-button'>
        <img src={support} alt='icon' />
      </button>
    </div>
  );
};
